export default [
    {
        "id": "products-1",
        "plugin": "List",
        "pluginId": 3,
        "name": "products",
        "html": require('./productsLists/productsList-1/html').default,
        "js": require("./productsLists/productsList-1/js").default,
        "minJs": require("./productsLists/productsList-1/minJs").default,
        "css": require('./productsLists/productsList-1/css').default,
        "cssTablet": require('./productsLists/productsList-1/cssTablet').default,
        "cssMobile": require('./productsLists/productsList-1/cssMobile').default,
        "scss": require('./productsLists/productsList-1/scss').default,
        "scssTablet": require('./productsLists/productsList-1/scssTablet').default,
        "scssMobile": require('./productsLists/productsList-1/scssMobile').default,
        "config": '{"ItemsPerPage": 21,"GET_pageId":"pageId","GET_sort":"sort","DefaultSort":1}',
        "showOptions": true,
        "predefinedPlugin": {
            "plugin": "ColorFilter",
            "pluginId": 8,
            "name": "color-filter",
            "config": `{"Text":"KOLOR\r\n|||\r\nBłękitny|#99CCFF\r\n||\r\nCzerwony|#FF3300\r\n||\r\nNiebieski|#3366FF\r\n||\r\nBrązowy|#964b00\r\n||\r\nCzarny|#000000\r\n||\r\nBiały|#FFFFFF\r\n||\r\nZłoty|#ffd700\r\n||\r\nRóżowy|#ffc0cb\r\n||\r\nTurkusowy|#76D7C4\r\n||\r\nWielokolorowy|multicolor\r\n||\r\nPomarańczowy|#fc9303\r\n||\r\nZielony|#008000\r\n||\r\nBeżowy|#c2b280\r\n||\r\nBordowy|#800000\r\n||\r\nCiemny szary|#909090\r\n||\r\nFioletowy|#87599d\r\n||\r\nGranatowy|#000080\r\n||\r\nSzary|#b4b4b4\r\n||\r\nZgniło zielony|#a5a542\r\n||\r\nŻółty|#ffef00"}`
        },
        "predefinedPlugin2": {
            "plugin": "NewPromo",
            "pluginId": 1,
            "name": "new-product",
        },
        "predefinedPlugin3": {
            "plugin": "manufacturer",
            "pluginId": 7,
            "name": "manufacturer-brand"
        },
        "predefinedPlugin4": {
            "plugin": "NewPromo",
            "pluginId": 1,
            "name": "recommended",
            "config": `{"Image":true,"TotalItems":12,"Type":7,"IncludeGroup":true}`
        },
        "settings": `{}`,
        "svgContent": require('./productsLists/productsList-1/svgContent').default,
        "svgViewBox": "0 0 1440 2486",
        "svgContentMobile": require('./productsLists/productsList-1/svgContentMobile').default,
        "svgViewBoxMobile": "0 0 360 1370",
        "folder": "productsLists",
        "file" : "productsList-1",
        "pages": 'ProductList'
    }
]